import React from 'react';

function MyApplication({applicant}) {
    console.log(applicant)
    return (
        <div>My application</div>
    );
}

export default MyApplication;